<template>
  <router-view />
</template>

<script>
export default {
  name: "app-peopleCourseWeekRegistration"
};
</script>

<style lang="scss" scoped></style>
